import type { TranslationValues } from '@shared/config/i18n'
import { z } from 'zod'

type Translate = (key: string, values?: TranslationValues) => string

export const createRegisterCardFormSchema = (t: Translate) =>
  z.object({
    cardNumber1: z.string().length(4, t('paymentMethods.creditCard.validation.cardNumberRequired')),
    cardNumber2: z.string().length(4, t('paymentMethods.creditCard.validation.cardNumberRequired')),
    cardNumber3: z.string().length(4, t('paymentMethods.creditCard.validation.cardNumberRequired')),
    cardNumber4: z.string().refine((val) => {
      return val.length === 3 || val.length === 4
    }, t('paymentMethods.creditCard.validation.cardNumberRequired')),
    cardExpiryMonth: z
      .string()
      .length(2, t('paymentMethods.creditCard.validation.expiryMonthRequired'))
      .refine((val) => {
        const month = parseInt(val)
        return month >= 1 && month <= 12
      }, t('paymentMethods.creditCard.validation.expiryMonthInvalid')),
    cardExpiryYear: z.string().length(2, t('paymentMethods.creditCard.validation.expiryYearRequired')),
    cardPassword: z.string().length(2, t('paymentMethods.creditCard.validation.passwordRequired')),
    birthDate: z.string().refine((val) => {
      return val.length === 6 || val.length === 10
    }, t('paymentMethods.creditCard.validation.birthDateRequired')),
  })

export const registerCardFormSchema = createRegisterCardFormSchema((key) => key)

export type RegisterCardFormValues = z.infer<ReturnType<typeof createRegisterCardFormSchema>>
export type RegisterCardFormErrors = Record<
  keyof RegisterCardFormValues,
  { hasError: true; errorMessage: string } | { hasError: false }
>

export type RegisterCardFormState = { values: RegisterCardFormValues; errors: RegisterCardFormErrors }
